import { Component, OnInit } from '@angular/core';
import {select, Store} from '@ngrx/store';
import {ParticleService} from '@core/services/particle.service';
import {ActivatedRoute, Router} from '@angular/router';
import {IWorkflowCollectionState} from '../../../workflow/store/workflow.reducer';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {TimeZoneService} from '@core/services/time-zone.service';
import {ProjectState} from '../../../projects/store/reducers/projects.reducer';
import {Guid} from 'guid-typescript';
import {Configuration} from '@shared/models/configuration';
import {CreateWorkflowAction, CleanWorkflowDataAction} from '../../../workflow/store/workflow.actions';
import {getWorkflowReducerState, isWorkflowCleanedUp} from '../../../workflow/store/workflow.selector';

@Component({
    standalone: false,
    selector: 'particle-pre-arrangement-export',
  templateUrl: './pre-arrangement-export.component.html',
  styleUrls: ['./pre-arrangement-export.component.scss']
})
export class PreArrangementExportComponent implements OnInit {
  workflowTemplate = 'generic-export-prearrangement-ui-workflow';
  workflowState$: any;
  workflowId: string;
  cleanedUp$: any;
  apiEndpointKey: string;
  includeArchives: boolean = false;
  constructor(private store: Store<IWorkflowCollectionState>,
              private particleService: ParticleService, private router: Router,
              private particleStore: Store<ParticleState>,
              private timeZoneService: TimeZoneService,
              private projectStore: Store<ProjectState>,
              private activatedRoute: ActivatedRoute) {
    this.workflowId =  Guid.create().toString();
    this.apiEndpointKey = 'Dac6Api';
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe( params => {

      if (params['includeArchives']) {
        this.includeArchives = params['includeArchives'];
      }
      const selected = Configuration.getSmartGridConfig('GENERIC_EXPORT-PREARRANGEMENT-SELECTED');
      const notSelected = Configuration.getSmartGridConfig('GENERIC-EXPORT-PREARRANGEMENT-NOT-SELECTED');

      selected.Parameters['INCLUDE_ARCHIVES'] = this.includeArchives;
      notSelected.Parameters['INCLUDE_ARCHIVES'] = this.includeArchives;

      const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
      const action = new CreateWorkflowAction(url, this.workflowId , 'Export', this.workflowTemplate);
      this.store.dispatch(action);
      this.workflowState$ = this.store.pipe(select(getWorkflowReducerState, this.workflowId ));
      this.workflowState$.subscribe(state => {
        if (state) {
          this.cleanWorkflow();
        }

      });
    });

  }
  cleanWorkflow() {
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.subscribe(state => {
      if (state === 'Finished' || state === 'Cancelled') {
        this.store.dispatch(new CleanWorkflowDataAction(this.workflowId));
        this.router.navigate(['..'], {relativeTo: this.activatedRoute})
      }
    });
  }
  onGridCellValueChange($event) {
    console.log('cell value change', $event);
  }

}
